import { HTTP_TOKEN } from "./http";

export const getTrackingCampaign = (campId, params) => {
  return HTTP_TOKEN.get(`tracking/campaign/${campId}`, { params }).then((result) => {
    return result.data;
  });
};


export const getTrackingAuto = (autoId, params) => {
  return HTTP_TOKEN.get(`tracking/auto/${autoId}`, { params }).then((result) => {
    return result.data;
  }); 
};
